import apiClient from '@/Services/Clients/apiClient';

const REPORT_BASE_URL = 'api/report';

class ReportService {

  public static getRequestReport(reportParams: any): Promise<any> {
    const resourceUrl = `${REPORT_BASE_URL}/${reportParams.requestId}/requestReport`;
    return apiClient.postBinaryData(resourceUrl, reportParams);
  }

  public static getUploadFolderReport(reportParams: any): Promise<any> {
    const resourceUrl = `${REPORT_BASE_URL}/${reportParams.selfResponseId}/uploadFolderReport`;
    return apiClient.postBinaryData(resourceUrl, reportParams);
  }
}

export default ReportService;
